





































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import CountTo from 'vue-count-to'
import { IMetricValues } from '@/api/types'

@Component({
  name: 'PanelGroup',
  components: {
    CountTo
  }
})
export default class extends Vue {
  @Prop({
    type: Array,
    required: true,
    default: () => {
      return []
    }
  })
  metrics!: Array<IMetricValues>;

  private metricSpan(): number {
    // change this when the # of panels changes.
    return 3
  }

  private handleSetLineChartData(type: string) {
    this.$emit('handle-set-line-chart-data', type)
  }

  metric(type: string): number {
    const found = this.metrics.find((item) => item.key === type)
    return found === undefined ? 0 : found.itemCount
  }
}
